import React, { FC } from 'react'
import { Wrapper } from './styled'

interface ComponentProps {
	children: React.ReactNode
	srcSource?: string
	className?: string
}

export const ImgComponent: FC<ComponentProps> = ({ srcSource = '', children, className }) => (
	<Wrapper className={className}>
		{srcSource && <source srcSet={srcSource} />}
		{children}
	</Wrapper>
)
